import withInputErrorMessage from '../withInputErrorMessage';
import withOptionsSelectValueInitById from './withOptionsSelectValueInitById';
import withFormikSelect from './withSelectFormik';

export const options = [
   { id: 'al', value: 'al', label: 'Alabama' },
   { id: 'ak', value: 'ak', label: 'Alaska' },
   { id: 'az', value: 'az', label: 'Arizona' },
   { id: 'ar', value: 'ar', label: 'Arkansas' },
   { id: 'ca', value: 'ca', label: 'California' },
   { id: 'co', value: 'co', label: 'Colorado' },
   { id: 'ct', value: 'ct', label: 'Connecticut' },
   { id: 'de', value: 'de', label: 'Delaware' },
   { id: 'dc', value: 'dc', label: 'District of Columbia' },
   { id: 'fl', value: 'fl', label: 'Florida' },
   { id: 'gu', value: 'gu', label: 'Guam' },
   { id: 'ga', value: 'ga', label: 'Georgia' },
   { id: 'hi', value: 'hi', label: 'Hawaii' },
   { id: 'id', value: 'id', label: 'Idaho' },
   { id: 'il', value: 'il', label: 'Illinois' },
   { id: 'in', value: 'in', label: 'Indiana' },
   { id: 'ia', value: 'ia', label: 'Iowa' },
   { id: 'ks', value: 'ks', label: 'Kansas' },
   { id: 'ky', value: 'ky', label: 'Kentucky' },
   { id: 'la', value: 'la', label: 'Louisiana' },
   { id: 'me', value: 'me', label: 'Maine' },
   { id: 'md', value: 'md', label: 'Maryland' },
   { id: 'ma', value: 'ma', label: 'Massachusetts' },
   { id: 'mi', value: 'mi', label: 'Michigan' },
   { id: 'mn', value: 'mn', label: 'Minnesota' },
   { id: 'ms', value: 'ms', label: 'Mississippi' },
   { id: 'mo', value: 'mo', label: 'Missouri' },
   { id: 'mt', value: 'mt', label: 'Montana' },
   { id: 'ne', value: 'ne', label: 'Nebraska' },
   { id: 'nv', value: 'nv', label: 'Nevada' },
   { id: 'nh', value: 'nh', label: 'New Hampshire' },
   { id: 'nj', value: 'nj', label: 'New Jersey' },
   { id: 'nm', value: 'nm', label: 'New Mexico' },
   { id: 'ny', value: 'ny', label: 'New York' },
   { id: 'nc', value: 'nc', label: 'North Carolina' },
   { id: 'nd', value: 'nd', label: 'North Dakota' },
   { id: 'oh', value: 'oh', label: 'Ohio' },
   { id: 'ok', value: 'ok', label: 'Oklahoma' },
   { id: 'or', value: 'or', label: 'Oregon' },
   { id: 'pa', value: 'pa', label: 'Pennsylvania' },
   { id: 'pr', value: 'pr', label: 'Puerto Rico' },
   { id: 'ri', value: 'ri', label: 'Rhode Island' },
   { id: 'sc', value: 'sc', label: 'South Carolina' },
   { id: 'sd', value: 'sd', label: 'South Dakota' },
   { id: 'tn', value: 'tn', label: 'Tennessee' },
   { id: 'tx', value: 'tx', label: 'Texas' },
   { id: 'ut', value: 'ut', label: 'Utah' },
   { id: 'vt', value: 'vt', label: 'Vermont' },
   { id: 'va', value: 'va', label: 'Virginia' },
   { id: 'vi', value: 'vi', label: 'Virgin Islands' },
   { id: 'wa', value: 'wa', label: 'Washington' },
   { id: 'wv', value: 'wv', label: 'West Virginia' },
   { id: 'wi', value: 'wi', label: 'Wisconsin' },
   { id: 'wy', value: 'wy', label: 'Wyoming' },
];

export default withFormikSelect(withInputErrorMessage(withOptionsSelectValueInitById(options)));
